import { useTranslation } from 'react-i18next'
import {
  Button,
  Icon,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import dayjs from 'dayjs'
import { DATE_FORMAT_DMY, DATE_FORMAT_DMY_TIME } from '@/constants'
import { InternalHoursLog } from '@/types'

export type InternalHoursLogsTableBodyProps = {
  rows: InternalHoursLog[]
  onOpenDetails: (id: number) => void
}

export const InternalHoursLogsTableBody = ({
  rows,
  onOpenDetails,
}: InternalHoursLogsTableBodyProps): JSX.Element => {
  const { t } = useTranslation('internalHours')

  return (
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          <TableCell>{row.id}</TableCell>
          <TableCell>
            {row.date ? dayjs(row.date).format(DATE_FORMAT_DMY) : '-'}
          </TableCell>
          <TableCell>{row.amount_hours}</TableCell>
          <TableCell>
            {row.report_type ? t(`logs.reportTypes.${row.report_type}`) : '-'}
          </TableCell>
          <TableCell>
            {row.leave_type ? t(`logs.leaveTypes.${row.leave_type}`) : '-'}
          </TableCell>
          <TableCell>{row.description || '-'}</TableCell>
          <TableCell>
            {row.created_at
              ? dayjs(row.created_at).format(DATE_FORMAT_DMY_TIME)
              : '-'}
          </TableCell>
          <TableCell align="right">
            <Button
              variant="text"
              onClick={() => onOpenDetails(row.id)}
              endIcon={
                <Icon
                  sx={{ fontSize: 14, lineHeight: '21px', fontWeight: 600 }}
                >
                  <ArrowForwardIcon sx={{ height: 14, width: 14 }} />
                </Icon>
              }
            >
              <Typography variant="body2" fontWeight={600}>
                {t('logs.buttons.view')}
              </Typography>
            </Button>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  )
}
